import { factory, primaryKey } from '@mswjs/data';

const models = {
  user: {
    _id: primaryKey(String),
    firstName: String,
    lastName: String,
    email: String,
    // username: String,
    avatar: String,
    referralLink: String,
    referralCode: String,
    referralCount: Number,
    referredBy: String,
    password: String,
    phoneNumber: String,
    isVerified: Boolean,
    isActivated: Boolean,
    verificationCode: String,
    courses: Array,
    country: String,
    address: String,
    isKYCVerified: Boolean,
    userType: String,
    createdAt: String,
    __v: Number,
  },
};

export const db = factory(models);

export type Model = 'user';

export const loadDb = () =>
  Object.assign(JSON.parse(window.localStorage.getItem('msw-db') || '{}'));

export const persistDb = (model: Model) => {
  if (process.env.NODE_ENV === 'test') return;
  const data = loadDb();
  data[model] = db[model].getAll();

  window.localStorage.setItem('msw-db', JSON.stringify(data));
};

export const initializeDb = () => {
  const database = loadDb();
  Object.entries(db).forEach(([key, model]) => {
    const dataEntres = database[key];
    if (dataEntres) {
      dataEntres?.forEach((entry: Record<string, any>) => {
        model.create(entry);
      });
    }
  });
};

export const resetDb = () => {
  window.localStorage.clear();
};

initializeDb();
